import * as React from "react";

interface Props {
	className?: string;
	small?: boolean;
}

export default function Spinner(props: Props) {
	return <div className={"spinner-border " + (props.small ? "spinner-border-sm " : "") + (props.className ? props.className : "")} role="status"></div>;
}